module.exports = __webpack_public_path__ + "369ae163ec2e8be93df8f8c79ff9ab2f.svg";